module.exports = __webpack_public_path__ + "img/asset3.f37c75dc.png";